export default {
    'please-select-account-filter': 'Please select account filter',
    'please-select-item-filter': 'Please select item filter',
    'customer-report': 'Customer report',
    'material-report': 'Material report'
}